export default __webpack_public_path__ + "99cfb12c9ff1a4253690ae423a22fd1b.xml";